/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-undef */
import React, { useState, useEffect, useContext, useRef } from "react";
import DashboardSidebar from "../sidebar/sidebar.jsx";
import StickyBox from "react-sticky-box";
// import HeaderTwo from "../newHeaderTwo.jsx";
import Footer from "../../home/footer.jsx";
import { Link } from "react-router-dom";
import Select from "react-select";
import ImageWithBasePath from "../../../core/img/imagewithbasebath.jsx";
import { AuthContext } from "../../../context/AuthContext";
import { getUserBalance, topUpWallet, getWalletStatement } from "../../../services/walletService";
import { toast } from "react-toastify";
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Navbar from "../../landingpage/sections/Navbar/index.jsx";

const FanAccounts = (props) => {
  const modalRef = useRef(null);
  const [show, setShow] = useState(true);
  const [balanceData, setBalanceData] = useState(null);
  const [statementData, setStatementData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [statementLoading, setStatementLoading] = useState(false);
  const [error, setError] = useState(null);
  const { user } = useContext(AuthContext);

  const [topUpAmount, setTopUpAmount] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [balanceData, statementData] = await Promise.all([
          getUserBalance(),
          getWalletStatement()
        ]);
        setBalanceData(balanceData);
        setStatementData(statementData);
        setError(null);
      } catch (err) {
        console.error("Error fetching data:", err);
        setError(err.message || "Failed to fetch data");

        // Try to at least get the balance if statement fails
        try {
          const balanceData = await getUserBalance();
          setBalanceData(balanceData);
        } catch (balanceErr) {
          console.error("Failed to fetch balance too:", balanceErr);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const refreshStatement = async () => {
    try {
      setStatementLoading(true);
      const statementData = await getWalletStatement();
      setStatementData(statementData);
      setCurrentPage(1); // Reset to first page when refreshing
      toast.success("Statement refreshed successfully");
    } catch (err) {
      console.error("Error refreshing statement:", err);
      toast.error("Failed to refresh statement");
    } finally {
      setStatementLoading(false);
    }
  };

  const handleTopUp = async (e) => {
    e.preventDefault();

    if (!topUpAmount || !phoneNumber) {
      toast.error("Please enter amount and phone number");
      return;
    }

    setIsProcessing(true);

    try {
      const cleanedPhoneNumber = phoneNumber.replace(/\D/g, '').slice(-9);

      if (cleanedPhoneNumber.length !== 9) {
        toast.error("Please enter a valid phone number with at least 9 digits");
        setIsProcessing(false);
        return;
      }

      const topUpData = {
        amount: parseInt(topUpAmount),
        phoneNumber: cleanedPhoneNumber
      };

      console.log("Sending top-up request...");

      // Make the API call with proper error handling
      const result = await topUpWallet(topUpData);
      console.log("Top-up response:", result);

      if (result.success) {
        toast.success(result.message || "Top-up successful!");

        // Refresh data
        const [balanceData, statementData] = await Promise.all([
          getUserBalance(),
          getWalletStatement()
        ]);
        setBalanceData(balanceData);
        setStatementData(statementData);
        setCurrentPage(1); // Go to first page to see the new transaction

        // Close modal and reset
        if (modalRef.current) {
          const bsModal = bootstrap.Modal.getInstance(modalRef.current);
          bsModal?.hide();
        }
        setTopUpAmount("");
        setPhoneNumber("");

      } else {
        // Backend returned success: false with an error message
        console.log("Backend returned failure:", result.message);
        toast.error(result.message || "Top-up failed");
      }

    } catch (error) {
      console.error("Top-up catch error:", error);

      // This will show the actual backend error message: "Top-up failed: Payment API is unreachable"
      toast.error(error.message || "Failed to process top-up");

    } finally {
      setIsProcessing(false);
    }
  };

  // Pagination functions
  const getCurrentTransactions = () => {
    if (!statementData?.data?.transactions) return [];

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return statementData.data.transactions.slice(startIndex, endIndex);
  };

  const totalPages = Math.ceil((statementData?.data?.transactions?.length || 0) / itemsPerPage);

  const goToPage = (page) => {
    setCurrentPage(page);
  };

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goToPrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  // Function to format transaction time
  const formatTransactionTime = (transaction) => {
    // First check for createdAt field
    if (transaction.createdAt) {
      const date = new Date(transaction.createdAt);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }

    // If no createdAt, check for timestamp or use current date as fallback
    if (transaction.timestamp) {
      const date = new Date(transaction.timestamp);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }

    // If no time information is available
    return 'N/A';
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'active':
      case 'completed':
      case 'confirmed':
        return 'badge badge-success-transparent';
      case 'pending':
        return 'badge badge-warning-transparent';
      case 'failed':
        return 'badge badge-danger-transparent';
      default:
        return 'badge badge-secondary-transparent';
    }
  };

  const getTransactionTypeBadge = (transactionType) => {
    switch (transactionType) {
      case 'Credit':
        return 'badge badge-success-transparent';
      case 'Debit':
        return 'badge badge-danger-transparent';
      default:
        return 'badge badge-secondary-transparent';
    }
  };

  // Generate page numbers for pagination
  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;

    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  };

  if (loading) {
    return (
      <div className="main-wrapper">
        <Navbar {...props} />
        <div className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                <StickyBox offsetTop={20} offsetBottom={20}>
                  <DashboardSidebar />
                </StickyBox>
              </div>
              <div className="col-lg-8 col-xl-9">
                <div className="d-flex justify-content-center align-items-center" style={{ height: "300px" }}>
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer {...props} />
      </div>
    );
  }

  if (error) {
    return (
      <div className="main-wrapper">
        <Navbar {...props} />
        <div className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                <StickyBox offsetTop={20} offsetBottom={20}>
                  <DashboardSidebar />
                </StickyBox>
              </div>
              <div className="col-lg-8 col-xl-9">
                <div className="alert alert-danger" role="alert">
                  Error: {error}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer {...props} />
      </div>
    );
  }

  const currentTransactions = getCurrentTransactions();

  return (
    <>
      <div className="main-wrapper">
        <Navbar {...props} />

        {/* Breadcrumb */}
        <div className="breadcrumb-bar"
          style={{
            backgroundColor: 'var(--breadcrumb-bg)',
            transition: 'background-color 0.3s ease'
          }}
        >
          <div className="container">
            <div className="row align-items-center inner-banner">
              <div className="col-md-12 col-12 text-center">
                <nav aria-label="breadcrumb" className="page-breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/home">
                        <i className="isax isax-home-15" />
                      </Link>
                    </li>
                    <li className="breadcrumb-item" aria-current="page">
                      Fan
                    </li>
                    <li className="breadcrumb-item active">Wallet</li>
                  </ol>
                  <h2 className="breadcrumb-title">Wallet</h2>
                </nav>
              </div>
            </div>
          </div>
          <div className="breadcrumb-bg">
            <ImageWithBasePath
              src="assets/img/bg/breadcrumb-bg-01.png"
              alt="img"
              className="breadcrumb-bg-01"
            />
            <ImageWithBasePath
              src="assets/img/bg/breadcrumb-bg-02.png"
              alt="img"
              className="breadcrumb-bg-02"
            />
            <ImageWithBasePath
              src="assets/img/bg/breadcrumb-icon.png"
              alt="img"
              className="breadcrumb-bg-03"
            />
            <ImageWithBasePath
              src="assets/img/bg/breadcrumb-icon.png"
              alt="img"
              className="breadcrumb-bg-04"
            />
          </div>
        </div>
        {/* /Breadcrumb */}

        <div className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                <StickyBox offsetTop={20} offsetBottom={20}>
                  <DashboardSidebar />
                </StickyBox>
              </div>

              <div className="col-lg-8 col-xl-9">
                <>
                  <div className="accunts-sec">
                    <div className="dashboard-header">
                      <div className="header-back">
                        <h3>Wallet</h3>
                        <button
                          className="btn btn-sm btn-outline-primary"
                          onClick={refreshStatement}
                          disabled={statementLoading}
                        >
                          {statementLoading ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                              Refreshing...
                            </>
                          ) : (
                            <>
                              <i className="fa-solid fa-refresh me-2"></i>
                              Refresh Statement
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                    <div className="account-details-box">
                      <div className="row">
                        <div className="col-xxl-7 col-lg-7">
                          <div className="account-payment-info">
                            <div className="row">
                              <div className="col-lg-6 col-md-6">
                                <div className="payment-amount">
                                  <h6>
                                    <i className="fa-solid fa-money-bill-1 text-orange" />
                                    Total Balance
                                  </h6>
                                  <span>{formatCurrency(balanceData?.data?.balance || 0)}</span>
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-6">
                                <div className="payment-amount">
                                  <h6>
                                    <i className="isax isax-document5 text-success" />
                                    Total Credits
                                  </h6>
                                  <span>{formatCurrency(statementData?.data?.summary?.totalCredits || 0)}</span>
                                </div>
                              </div>
                            </div>
                            <div className="payment-request">
                              <span>Total Transactions: {statementData?.data?.summary?.totalTransactions || 0}</span>
                              <Link
                                to="#payment_request"
                                className="btn btn-md btn-primary-gradient rounded-pill"
                                data-bs-toggle="modal"
                              >
                                Deposit Money
                              </Link>
                            </div>
                          </div>
                        </div>
                        <div className="col-xxl-5 col-lg-5">
                          <div className="bank-details-info">
                            <h3>Account Details</h3>
                            <ul>
                              <li>
                                <h6>Bank Name</h6>
                                <h3>One money</h3>
                              </li>
                              <li>
                                <h6>Account Number</h6>
                                <h3>{user?.userPhone || '+263734588900'}</h3>
                              </li>
                              <li>
                                <h6>Account Type</h6>
                                <h3>Mobile</h3>
                              </li>
                              <li>
                                <h6>Account Name</h6>
                                <h3>{user?.fullName || 'User'}</h3>
                              </li>
                            </ul>
                            <div className="edit-detail-link d-flex align-items-center justify-content-between w-100">
                              <div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Transaction History Table with Real Data */}
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="account-detail-table">
                        <div className="custom-new-table">
                          <div className="table-header d-flex justify-content-between align-items-center mb-3">
                            <h5>Transaction History</h5>
                            <span className="text-muted">
                              Showing {currentTransactions.length} of {statementData?.data?.transactions?.length || 0} transactions
                            </span>
                          </div>
                          <div className="table-responsive">
                            <table className="table table-center mb-0">
                              <thead>
                                <tr>
                                  <th>Transaction ID</th>
                                  <th>Type</th>
                                  <th>Date</th>
                                  <th>Phone Number</th>
                                  <th>Amount</th>
                                  <th>Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                {currentTransactions.length > 0 ? (
                                  currentTransactions.map((transaction) => (
                                    <tr key={transaction._id}>
                                      <td>
                                        <Link to="#" className="link-primary">
                                          #{transaction._id.slice(-8)}
                                        </Link>
                                      </td>
                                      <td>
                                        <span className={getTransactionTypeBadge(transaction.transactionType)}
                                          style={{
                                            fontSize: '0.9rem',
                                            padding: '3px 8px',
                                            borderRadius: '10px',
                                            fontWeight: '700'
                                          }}
                                        >
                                          {transaction.transactionType}
                                        </span>
                                      </td>
                                      <td className="text-gray-9">
                                        {formatTransactionTime(transaction)}
                                      </td>
                                      <td>{transaction.phoneNumber || 'N/A'}</td>
                                      <td>{formatCurrency(transaction.amount)}</td>
                                      <td>
                                        <span className={getStatusBadge(transaction.status)}
                                          style={{
                                            fontSize: '0.9rem',
                                            padding: '3px 8px',
                                            borderRadius: '10px',
                                            fontWeight: '700'
                                          }}>
                                          <i className="fa-solid fa-circle me-1 fs-5" />
                                          {transaction.status}
                                        </span>
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan="6" className="text-center py-4">
                                      <div className="alert alert-info mb-0">
                                        <i className="fa fa-info-circle me-2"></i>
                                        No transactions found.
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>

                          {/* Pagination */}
                          {totalPages > 1 && (
                            <div className="pagination-container mt-4">
                              <nav aria-label="Transaction pagination">
                                <ul className="pagination justify-content-center mb-0">
                                  {/* Previous Page */}
                                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                    <button
                                      className="page-link"
                                      onClick={goToPrevPage}
                                      disabled={currentPage === 1}
                                    >
                                      <i className="fas fa-chevron-left"></i> Previous
                                    </button>
                                  </li>

                                  {/* Page Numbers */}
                                  {getPageNumbers().map(page => (
                                    <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                      <button
                                        className="page-link"
                                        onClick={() => goToPage(page)}
                                      >
                                        {page}
                                      </button>
                                    </li>
                                  ))}

                                  {/* Next Page */}
                                  <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                    <button
                                      className="page-link"
                                      onClick={goToNextPage}
                                      disabled={currentPage === totalPages}
                                    >
                                      Next <i className="fas fa-chevron-right"></i>
                                    </button>
                                  </li>
                                </ul>
                              </nav>
                              <div className="text-center text-muted mt-2">
                                Page {currentPage} of {totalPages}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>

              </div>
            </div>
          </div>
        </div>

        <Footer {...props} />
      </div>

      {/* Payment Modal */}
      <div className="modal fade custom-modals" id="payment_request" ref={modalRef}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Deposit Money</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                disabled={isProcessing}
              >
                <i className="fa-solid fa-xmark" />
              </button>
            </div>
            <form onSubmit={handleTopUp}>
              <div className="modal-body pb-0">
                <div className="mb-3">
                  <label className="form-label">
                    Enter Amount <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={topUpAmount}
                    onChange={(e) => setTopUpAmount(e.target.value)}
                    min="1"
                    required
                    disabled={isProcessing}
                    placeholder="Enter amount to deposit"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Phone Number <span className="text-danger">*</span>
                  </label>
                  <input
                    type="tel"
                    className="form-control"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    required
                    disabled={isProcessing}
                    placeholder="Enter phone number"
                  />
                </div>
                <div className="alert alert-info">
                  <small>
                    The phone number you enter above will be prompted to complete the payment.
                  </small>
                </div>
              </div>
              <div className="modal-footer">
                <div className="modal-btn text-end">
                  <button
                    type="button"
                    className="btn btn-md btn-dark rounded-pill"
                    data-bs-dismiss="modal"
                    disabled={isProcessing}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-md btn-primary-gradient rounded-pill"
                    disabled={isProcessing}
                  >
                    {isProcessing ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Processing...
                      </>
                    ) : (
                      "Add to Wallet"
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Payment Modal */}
    </>
  );
};

export default FanAccounts;


// /* eslint-disable no-unused-vars */
// /* eslint-disable react/jsx-no-undef */
// import React, { useState, useEffect, useContext, useRef } from "react";
// import DashboardSidebar from "../sidebar/sidebar.jsx";
// import StickyBox from "react-sticky-box";
// import HeaderTwo from "../newHeaderTwo.jsx";
// import Footer from "../../home/footer.jsx";
// import { Link } from "react-router-dom";
// import Select from "react-select";
// import ImageWithBasePath from "../../../core/img/imagewithbasebath.jsx";
// import { AuthContext } from "../../../context/AuthContext";
// import { getUserBalance, topUpWallet, getWalletStatement } from "../../../services/walletService";
// import { toast } from "react-toastify";
// import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';

// const FanAccounts = (props) => {
//   const modalRef = useRef(null);
//   const [show, setShow] = useState(true);
//   const [balanceData, setBalanceData] = useState(null);
//   const [statementData, setStatementData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [statementLoading, setStatementLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const { user } = useContext(AuthContext);

//   const [topUpAmount, setTopUpAmount] = useState("");
//   const [phoneNumber, setPhoneNumber] = useState("");
//   const [isProcessing, setIsProcessing] = useState(false);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);
//         const [balanceData, statementData] = await Promise.all([
//           getUserBalance(),
//           getWalletStatement()
//         ]);
//         setBalanceData(balanceData);
//         setStatementData(statementData);
//         setError(null);
//       } catch (err) {
//         console.error("Error fetching data:", err);
//         setError(err.message || "Failed to fetch data");

//         // Try to at least get the balance if statement fails
//         try {
//           const balanceData = await getUserBalance();
//           setBalanceData(balanceData);
//         } catch (balanceErr) {
//           console.error("Failed to fetch balance too:", balanceErr);
//         }
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   const refreshStatement = async () => {
//     try {
//       setStatementLoading(true);
//       const statementData = await getWalletStatement();
//       setStatementData(statementData);
//       toast.success("Statement refreshed successfully");
//     } catch (err) {
//       console.error("Error refreshing statement:", err);
//       toast.error("Failed to refresh statement");
//     } finally {
//       setStatementLoading(false);
//     }
//   };

//   const handleTopUp = async (e) => {
//     e.preventDefault();

//     if (!topUpAmount || !phoneNumber) {
//       toast.error("Please enter amount and phone number");
//       return;
//     }

//     setIsProcessing(true);

//     try {
//       const cleanedPhoneNumber = phoneNumber.replace(/\D/g, '').slice(-9);

//       if (cleanedPhoneNumber.length !== 9) {
//         toast.error("Please enter a valid phone number with at least 9 digits");
//         setIsProcessing(false);
//         return;
//       }

//       const topUpData = {
//         amount: parseInt(topUpAmount),
//         phoneNumber: cleanedPhoneNumber
//       };

//       console.log("Sending top-up request...");

//       // Make the API call with proper error handling
//       const result = await topUpWallet(topUpData);
//       console.log("Top-up response:", result);

//       if (result.success) {
//         toast.success(result.message || "Top-up successful!");

//         // Refresh data
//         const [balanceData, statementData] = await Promise.all([
//           getUserBalance(),
//           getWalletStatement()
//         ]);
//         setBalanceData(balanceData);
//         setStatementData(statementData);

//         // Close modal and reset
//         if (modalRef.current) {
//           const bsModal = bootstrap.Modal.getInstance(modalRef.current);
//           bsModal?.hide();
//         }
//         setTopUpAmount("");
//         setPhoneNumber("");

//       } else {
//         // Backend returned success: false with an error message
//         console.log("Backend returned failure:", result.message);
//         toast.error(result.message || "Top-up failed");
//       }

//     } catch (error) {
//       console.error("Top-up catch error:", error);

//       // This will show the actual backend error message: "Top-up failed: Payment API is unreachable"
//       toast.error(error.message || "Failed to process top-up");

//     } finally {
//       setIsProcessing(false);
//     }
//   };
//   // const handleTopUp = async (e) => {
//   //   e.preventDefault();

//   //   if (!topUpAmount || !paymentGateway) {
//   //     toast.error("Please enter amount and select payment gateway");
//   //     return;
//   //   }

//   //   setIsProcessing(true);

//   //   try {
//   //     const topUpData = {
//   //       amount: parseInt(topUpAmount),
//   //       phoneNumber: "713388202" // Always use this specific number for STK push
//   //     };

//   //     const result = await topUpWallet(topUpData);

//   //     if (result.success) {
//   //       toast.success(result.message || "Top-up successful!");

//   //       // Refresh both balance and statement data
//   //       const [balanceData, statementData] = await Promise.all([
//   //         getUserBalance(),
//   //         getWalletStatement()
//   //       ]);
//   //       setBalanceData(balanceData);
//   //       setStatementData(statementData);

//   //       // Close the modal
//   //       if (modalRef.current) {
//   //         const bsModal = bootstrap.Modal.getInstance(modalRef.current);
//   //         if (bsModal) {
//   //           bsModal.hide();
//   //         } else {
//   //           // If no instance exists, create one and hide it
//   //           new bootstrap.Modal(modalRef.current).hide();
//   //         }
//   //       }

//   //       // Reset form
//   //       setTopUpAmount("");
//   //       setPaymentGateway("");
//   //     } else {
//   //       toast.error(result.message || "Top-up failed");
//   //     }
//   //   } catch (error) {
//   //     console.error("Top-up error:", error);
//   //     toast.error(error.message || "Failed to process top-up");
//   //   } finally {
//   //     setIsProcessing(false);
//   //   }
//   // };

//   const formatCurrency = (amount) => {
//     return new Intl.NumberFormat('en-US', {
//       style: 'currency',
//       currency: 'USD'
//     }).format(amount);
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric'
//     });
//   };

//   const getStatusBadge = (status) => {
//     switch (status) {
//       case 'active':
//       case 'completed':
//       case 'confirmed':
//         return 'badge badge-success-transparent';
//       case 'pending':
//         return 'badge badge-warning-transparent';
//       case 'failed':
//         return 'badge badge-danger-transparent';
//       default:
//         return 'badge badge-secondary-transparent';
//     }
//   };

//   const getTransactionTypeBadge = (transactionType) => {
//     switch (transactionType) {
//       case 'Credit':
//         return 'badge badge-success-transparent';
//       case 'Debit':
//         return 'badge badge-danger-transparent';
//       default:
//         return 'badge badge-secondary-transparent';
//     }
//   };

//   if (loading) {
//     return (
//       <div className="main-wrapper">
//         <HeaderTwo {...props} />
//         <div className="content">
//           <div className="container">
//             <div className="row">
//               <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
//                 <StickyBox offsetTop={20} offsetBottom={20}>
//                   <DashboardSidebar />
//                 </StickyBox>
//               </div>
//               <div className="col-lg-8 col-xl-9">
//                 <div className="d-flex justify-content-center align-items-center" style={{ height: "300px" }}>
//                   <div className="spinner-border text-primary" role="status">
//                     <span className="visually-hidden">Loading...</span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         <Footer {...props} />
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="main-wrapper">
//         <HeaderTwo {...props} />
//         <div className="content">
//           <div className="container">
//             <div className="row">
//               <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
//                 <StickyBox offsetTop={20} offsetBottom={20}>
//                   <DashboardSidebar />
//                 </StickyBox>
//               </div>
//               <div className="col-lg-8 col-xl-9">
//                 <div className="alert alert-danger" role="alert">
//                   Error: {error}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         <Footer {...props} />
//       </div>
//     );
//   }

//   return (
//     <>
//       <div className="main-wrapper">
//         <HeaderTwo {...props} />

//         {/* Breadcrumb */}
//         <div className="breadcrumb-bar"
//           style={{
//             backgroundColor: 'var(--breadcrumb-bg)',
//             transition: 'background-color 0.3s ease'
//           }}
//         >
//           <div className="container">
//             <div className="row align-items-center inner-banner">
//               <div className="col-md-12 col-12 text-center">
//                 <nav aria-label="breadcrumb" className="page-breadcrumb">
//                   <ol className="breadcrumb">
//                     <li className="breadcrumb-item">
//                       <Link to="/home">
//                         <i className="isax isax-home-15" />
//                       </Link>
//                     </li>
//                     <li className="breadcrumb-item" aria-current="page">
//                       Fan
//                     </li>
//                     <li className="breadcrumb-item active">Wallet</li>
//                   </ol>
//                   <h2 className="breadcrumb-title">Wallet</h2>
//                 </nav>
//               </div>
//             </div>
//           </div>
//           <div className="breadcrumb-bg">
//             <ImageWithBasePath
//               src="assets/img/bg/breadcrumb-bg-01.png"
//               alt="img"
//               className="breadcrumb-bg-01"
//             />
//             <ImageWithBasePath
//               src="assets/img/bg/breadcrumb-bg-02.png"
//               alt="img"
//               className="breadcrumb-bg-02"
//             />
//             <ImageWithBasePath
//               src="assets/img/bg/breadcrumb-icon.png"
//               alt="img"
//               className="breadcrumb-bg-03"
//             />
//             <ImageWithBasePath
//               src="assets/img/bg/breadcrumb-icon.png"
//               alt="img"
//               className="breadcrumb-bg-04"
//             />
//           </div>
//         </div>
//         {/* /Breadcrumb */}

//         <div className="content">
//           <div className="container">
//             <div className="row">
//               <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
//                 <StickyBox offsetTop={20} offsetBottom={20}>
//                   <DashboardSidebar />
//                 </StickyBox>
//               </div>

//               <div className="col-lg-8 col-xl-9">
//                 <>
//                   <div className="accunts-sec">
//                     <div className="dashboard-header">
//                       <div className="header-back">
//                         <h3>Wallet</h3>
//                         <button
//                           className="btn btn-sm btn-outline-primary"
//                           onClick={refreshStatement}
//                           disabled={statementLoading}
//                         >
//                           {statementLoading ? (
//                             <>
//                               <span className="spinner-border spinner-border-sm me-2" role="status"></span>
//                               Refreshing...
//                             </>
//                           ) : (
//                             <>
//                               <i className="fa-solid fa-refresh me-2"></i>
//                               Refresh Statement
//                             </>
//                           )}
//                         </button>
//                       </div>
//                     </div>
//                     <div className="account-details-box">
//                       <div className="row">
//                         <div className="col-xxl-7 col-lg-7">
//                           <div className="account-payment-info">
//                             <div className="row">
//                               <div className="col-lg-6 col-md-6">
//                                 <div className="payment-amount">
//                                   <h6>
//                                     <i className="fa-solid fa-money-bill-1 text-orange" />
//                                     Total Balance
//                                   </h6>
//                                   <span>{formatCurrency(balanceData?.data?.balance || 0)}</span>
//                                 </div>
//                               </div>
//                               <div className="col-lg-6 col-md-6">
//                                 <div className="payment-amount">
//                                   <h6>
//                                     <i className="isax isax-document5 text-success" />
//                                     Total Credits
//                                   </h6>
//                                   <span>{formatCurrency(statementData?.data?.summary?.totalCredits || 0)}</span>
//                                 </div>
//                               </div>
//                             </div>
//                             <div className="payment-request">
//                               <span>Total Transactions: {statementData?.data?.summary?.totalTransactions || 0}</span>
//                               <Link
//                                 to="#payment_request"
//                                 className="btn btn-md btn-primary-gradient rounded-pill"
//                                 data-bs-toggle="modal"
//                               >
//                                 Deposit Money
//                               </Link>
//                             </div>
//                           </div>
//                         </div>
//                         <div className="col-xxl-5 col-lg-5">
//                           <div className="bank-details-info">
//                             <h3>Account Details</h3>
//                             <ul>
//                               <li>
//                                 <h6>Bank Name</h6>
//                                 <h3>One money</h3>
//                               </li>
//                               <li>
//                                 <h6>Account Number</h6>
//                                 <h3>{user?.userPhone || '+263734588900'}</h3>
//                               </li>
//                               <li>
//                                 <h6>Account Type</h6>
//                                 <h3>Mobile</h3>
//                               </li>
//                               <li>
//                                 <h6>Account Name</h6>
//                                 <h3>{user?.fullName || 'User'}</h3>
//                               </li>
//                             </ul>
//                             <div className="edit-detail-link d-flex align-items-center justify-content-between w-100">
//                               <div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Transaction History Table with Real Data */}
//                   <div className="row">
//                     <div className="col-sm-12">
//                       <div className="account-detail-table">
//                         <div className="custom-new-table">
//                           <div className="table-header d-flex justify-content-between align-items-center mb-3">
//                             <h5>Transaction History</h5>
//                             <span className="text-muted">
//                               Showing {statementData?.data?.transactions?.length || 0} of {statementData?.data?.pagination?.totalTransactions || 0} transactions
//                             </span>
//                           </div>
//                           <div className="table-responsive">
//                             <table className="table table-center mb-0">
//                               <thead>
//                                 <tr>
//                                   <th>Transaction ID</th>
//                                   <th>Type</th>
//                                   <th>Reference</th>
//                                   <th>Phone Number</th>
//                                   <th>Amount</th>
//                                   <th>Status</th>
//                                 </tr>
//                               </thead>
//                               <tbody>
//                                 {statementData?.data?.transactions?.length > 0 ? (
//                                   statementData.data.transactions.map((transaction) => (
//                                     <tr key={transaction._id}>
//                                       <td>
//                                         <Link to="#" className="link-primary">
//                                           #{transaction._id.slice(-8)}
//                                         </Link>
//                                       </td>
//                                       <td>
//                                         <span className={getTransactionTypeBadge(transaction.transactionType)}>
//                                           {transaction.transactionType}
//                                         </span>
//                                       </td>
//                                       <td className="text-gray-9">{transaction.transRef || transaction.referenceId || 'N/A'}</td>
//                                       <td>{transaction.phoneNumber || 'N/A'}</td>
//                                       <td>{formatCurrency(transaction.amount)}</td>
//                                       <td>
//                                         <span className={getStatusBadge(transaction.status)}>
//                                           <i className="fa-solid fa-circle me-1 fs-5" />
//                                           {transaction.status}
//                                         </span>
//                                       </td>
//                                     </tr>
//                                   ))
//                                 ) : (
//                                   <tr>
//                                     <td colSpan="6" className="text-center py-4">
//                                       <div className="alert alert-info mb-0">
//                                         <i className="fa fa-info-circle me-2"></i>
//                                         No transactions found.
//                                       </div>
//                                     </td>
//                                   </tr>
//                                 )}
//                               </tbody>
//                             </table>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </>

//               </div>
//             </div>
//           </div>
//         </div>

//         <Footer {...props} />
//       </div>

//       {/* Payment Modal */}
//       <div className="modal fade custom-modals" id="payment_request" ref={modalRef}>
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">Deposit Money</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//                 disabled={isProcessing}
//               >
//                 <i className="fa-solid fa-xmark" />
//               </button>
//             </div>
//             <form onSubmit={handleTopUp}>
//               <div className="modal-body pb-0">
//                 <div className="mb-3">
//                   <label className="form-label">
//                     Enter Amount <span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="number"
//                     className="form-control"
//                     value={topUpAmount}
//                     onChange={(e) => setTopUpAmount(e.target.value)}
//                     min="1"
//                     required
//                     disabled={isProcessing}
//                     placeholder="Enter amount to deposit"
//                   />
//                 </div>
//                 <div className="mb-3">
//                   <label className="form-label">
//                     Phone Number <span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="tel"
//                     className="form-control"
//                     value={phoneNumber}
//                     onChange={(e) => setPhoneNumber(e.target.value)}
//                     required
//                     disabled={isProcessing}
//                     placeholder="Enter phone number"
//                   />
//                 </div>
//                 <div className="alert alert-info">
//                   <small>
//                     The phone number you enter above will be prompted to complete the payment.
//                   </small>
//                 </div>
//               </div>
//               <div className="modal-footer">
//                 <div className="modal-btn text-end">
//                   <button
//                     type="button"
//                     className="btn btn-md btn-dark rounded-pill"
//                     data-bs-dismiss="modal"
//                     disabled={isProcessing}
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="submit"
//                     className="btn btn-md btn-primary-gradient rounded-pill"
//                     disabled={isProcessing}
//                   >
//                     {isProcessing ? (
//                       <>
//                         <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
//                         Processing...
//                       </>
//                     ) : (
//                       "Add to Wallet"
//                     )}
//                   </button>
//                 </div>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//       {/* /Payment Modal */}
//     </>
//   );
// };

// export default FanAccounts;